import { Button, Form, Input } from 'antd';
import React, { useState } from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import FormItem from 'components/FormItem';
import Toast from 'components/Toast';
import Track from 'components/Track';
import { eventType, processType } from '../../helper';
import store from '../../modules/Modify/store';
import { SecurityActionType } from '../../type';

import './style.scss';

/**
 *  验证登录密码
 */
interface ConfirmPwdProps {
    type: SecurityActionType;
    nextStep?: number;
}

const ConfirmPwd: React.FC<ConfirmPwdProps> = ({ type, nextStep }) => {
    const [loading, setLoading] = useState(false);
    const $formutil = useForm<{ login_password: string }>();
    const navigate = useNavigate();

    const submit = async () => {
        const { $params, $getFirstError, $invalid, $batchDirty } = $formutil;

        if ($invalid) {
            Toast.show($getFirstError());

            $batchDirty(true);
        } else {
            try {
                setLoading(true);

                const ret = await store.verifyPwd({
                    ...$params,
                    process: processType[type]
                });

                // 通过state传递至下一步
                navigate(`../${nextStep || '2'}`, { state: { verify_token: ret.data.verify_token } });
            } catch (error) {
                Toast.show(error);
            }

            setLoading(false);
        }
    };

    return (
        <Form layout="vertical" className="confirm-pwd-page" onFinish={submit}>
            <FormItem
                label={__('登录密码')}
                name="login_password"
                required
                validMessage={{ required: __('登录密码不能为空') }}>
                <Input type="password" placeholder={__('登录密码')} />
            </FormItem>
            <CardButtonWrap>
                <Track
                    eventModel="安全中心"
                    eventType={eventType[type]}
                    eventName={type === 'modifyPassword' ? '登录密码修改_登录密码确认' : '修改_登录密码确认'}>
                    <Button
                        block
                        type="primary"
                        size="large"
                        loading={loading}
                        htmlType="submit"
                        className="btn-important"
                        disabled={!$formutil.$params.login_password}>
                        {__('下一步')}
                    </Button>
                </Track>
            </CardButtonWrap>
        </Form>
    );
};

export default withForm(ConfirmPwd);
